const reimburse = {
  plCode: 'Please enter code',
  plName: 'Please enter name',
  plDesc: 'Please enter description',
  disableTip: 'Are you sure to disable this category',
  disableConfirm: 'Disable Confirm',
  disableConfirmContent: 'Confirm disable category',
  disableSuccess: 'Disable Success',
  disableSuccessDesc: 'has been disabled',
  disableFailed: 'Disable Failed',
  disableFailedHasSubs: 'This category has subcategories and cannot be disabled',
  addSuccessDesc: 'added successfully',
  updateSuccessDesc: 'updated successfully',
  addFailed: 'Add failed',
  codeDuplicate: 'Code already exists',
  applicationTypeLabel: 'Application Type',
  approveTypeLabel: 'Approve Method',
  stepCount: 'Steps',
  reimbursement: 'Reimbursement',
  dailySupplies: 'Daily Supplies/Materials',
  materialOverIssue: 'Over-picking Material Request',
  addMaterialOverIssue: 'Add Over-picking Material Request',
  materialOverIssueList: 'Over-picking Material Request List',
  inOrder: 'In Order',
  any: 'Any Step Approved',
  last: 'Final Step Approved',
  templateConfig: 'Template Config',
  approvalSteps: 'Approval Steps',
  step: 'Step',
  addStep: 'Add Step',
  specificOrgAnyone: 'Specific Org Anyone',
  applicantOrgAnyone: 'Applicant Org Anyone',
  specificUsers: 'Specific Users',
  plSelectOrg: 'Please enter org ID',
  plOrgId: 'Org ID',
  plSelectUsers: 'Please select users',
  number: 'Number',
  title: 'Title',
  status: 'Status',
  statusAll: 'All',
  statusDraft: 'Draft',
  statusPending: 'Pending',
  statusApproved: 'Approved',
  statusRejected: 'Rejected',
  statusReturned: 'Returned',
  applicationList: 'Application List',
  addApplication: 'Add',
  plTitle: 'Please enter title',
  plContent: 'Please enter content',
  plPurpose: 'Please enter purpose',
  plRemark: 'Please enter remark',
  content: 'Content',
  purpose: 'Purpose',
  remark: 'Remark',
  items: 'Items',
  itemList: 'Application Item List',
  count: 'Count',
  selectProducts: 'Add by Part No.',
  plSelectProducts: 'Please select products',
  submit: 'Submit',
  reSubmit: 'Resubmit',
  submitSuccess: 'Submit Success',
  submitFailed: 'Submit Failed',
  amount: 'Amount',
  orderAmount: 'Planned Pick Quantity',
  productId: 'Product ID',
  requirementItemId: 'Requirement Item',
  overCount: 'Over-picked Quantity',
  reasonType: 'Over-picking Reason',
  reasonMistake: 'Mistake',
  reasonWaste: 'Waste',
  reasonOther: 'Other',
  reason: 'Details',
  picked: 'Outbound Order Generated',
  pickedYes: 'Yes',
  pickedNo: 'No',
  expenseDate: 'Expense Date',
  invoiceCount: 'Invoice Count',
  plAmount: 'Please enter amount',
  plInvoiceCount: 'Please enter invoice count',
  plExpenseDate: 'Please select expense date',
  atLeastOne: 'At least one item is required',
  submitConfirm: 'Are you sure to submit the reimbursement?',
  submitOverIssueConfirm: 'Are you sure to submit the over-picking material request?',
  addDailyItem: 'Add without Part No.',
  approver: 'Approver',
  actualApprover: 'Actual Approver',
  approveTime: 'Approve Time',
  approveOrg: 'Approve Org',
  applicant: 'Applicant',
  submitTime: 'Submit Time',
  completeTime: 'Complete Time',
  stepNo: 'Step',
  pass: 'Pass',
  reject: 'Reject',
  return: 'Return',
  passSuccess: 'Passed',
  rejectSuccess: 'Rejected',
  returnSuccess: 'Returned',
  passFailed: 'Pass failed',
  rejectFailed: 'Reject failed',
  returnFailed: 'Return failed',
  confirmPass: 'Are you sure to approve?',
  confirmReject: 'Are you sure to reject?',
  confirmReturn: 'Are you sure to return?',
  approveRemark: 'Approve Remark',
  timeout: 'Timeout',
  approvalTimeLimit: 'Approval Time Limit',
  enableConfirm: 'Enable Confirm',
  disableCascadeTip: 'Disabling this category will also disable all subcategories',
  enableCascadeTip: 'Enabling this category will also enable all subcategories',
};

export default reimburse;
